import { render, staticRenderFns } from "./DialogConfirmacaoTempoCobertura.vue?vue&type=template&id=70c46e89"
import script from "./DialogConfirmacaoTempoCobertura.vue?vue&type=script&lang=js"
export * from "./DialogConfirmacaoTempoCobertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports